function FrenchPolynesia({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1202)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
        <path d="M1.94543 8.34781H30.0545C27.3409 3.37431 22.0647 0 16 0C9.93531 0 4.65912 3.37431 1.94543 8.34781Z" fill="#D80027"/>
        <path d="M16 32.0002C22.0647 32.0002 27.3409 28.6258 30.0545 23.6523H1.94543C4.65912 28.6258 9.93531 32.0002 16 32.0002Z" fill="#D80027"/>
        <path d="M21.5652 15.9998C21.5652 19.0734 19.0736 20.8693 16 20.8693C12.9264 20.8693 10.4348 19.0734 10.4348 15.9998C10.4348 12.9261 12.9264 10.4346 16 10.4346C19.0736 10.4346 21.5652 12.9261 21.5652 15.9998Z" fill="#FFDA44"/>
        <path d="M21.5652 16C21.5652 19.0736 19.0736 21.5652 16 21.5652C12.9264 21.5652 10.4348 19.0736 10.4348 16" fill="#0052B4"/>
        <path d="M12.5217 14.6089H13.913V17.3915H12.5217V14.6089Z" fill="#D80027"/>
        <path d="M18.0869 14.6089H19.4782V17.3915H18.0869V14.6089Z" fill="#D80027"/>
        <path d="M15.3043 12.522H16.6956V17.3915H15.3043V12.522Z" fill="#D80027"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default FrenchPolynesia;
